<template>
    <v-dialog v-model="projectGalleryDialog" hide-overlay persistent no-click-animation dark>
        <div component="ProjectGalleryDialog">
            <v-card class="wrapper">
                <v-card-title class="title">
                    <v-icon>drag_handle</v-icon>
                </v-card-title>
                <btn
                    :icon="'close'"
                    size="icon"
                    color="transparent"
                    for-background="dark"
                    @click="projectGalleryDialog = false"
                />
                <div class="iframe">
                    <iframe :src="galleryUrl" frameborder="0"></iframe>
                </div>
            </v-card>
        </div>
    </v-dialog>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from 'vuex';
import moment from 'moment';

export default {
    name: 'ProjectGalleryDialog',

    data() {
        return {};
    },

    methods: {
        ...mapActions([]),
        ...mapMutations(['setProjectGalleryDialog']),
    },

    computed: {
        ...mapGetters(['getProjectGalleryDialog']),

        galleryUrl: {
            get() {
                return `https://is.voicecasting.sk/app/Gallery/gallery.php?id=${this.getProjectGalleryDialog.actor}`;
            },
            set(value) {},
        },

        projectGalleryDialog: {
            get: function () {
                return this.getProjectGalleryDialog.visible;
            },
            set: function (val) {
                this.setProjectGalleryDialog({ visible: val, actor: this.getProjectGalleryDialog.actor });
            },
        },
    },

    components: {},
};
</script>

<style lang="less" scoped>
@import '~@variables';

[component='ProjectGalleryDialog'] {
    .iframe {
        width: 98vw;
        height: 90vh;
        max-width: 860px;
        max-height: 860px;

        iframe {
            height: 100%;
            width: 100%;
            max-width: 860px;
            max-height: 860px;
        }
    }

    .wrapper {
        position: relative;

        button {
            position: absolute;
            right: 0;
            top: 0;
        }
    }

    .title {
        padding: 0;
        display: flex;
        justify-content: center;

        .v-icon {
            &:hover {
                cursor: grab;
            }

            &:active {
                cursor: grabbing;
            }
        }
    }
}
</style>
